import React, { useRef, useEffect } from 'react';

const ProviderSelector = ({
  providers,
  filteredProviders,
  loading,
  error,
  providerSearchText,
  setProviderSearchText,
  showProviderDropdown,
  setShowProviderDropdown,
  selectedProviderId,
  onProviderSelect
}) => {
  const providerInputRef = useRef(null);
  const providerDropdownRef = useRef(null);

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        providerInputRef.current &&
        providerDropdownRef.current &&
        !providerInputRef.current.contains(event.target) &&
        !providerDropdownRef.current.contains(event.target)
      ) {
        setShowProviderDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setShowProviderDropdown]);

  const selectedProvider = providers.find(p => p.id === selectedProviderId);
  const displayValue = selectedProvider ? selectedProvider.name : providerSearchText;

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Service Provider <span className="text-red-500">*</span>
      </label>
      <div className="relative" ref={providerInputRef}>
        <input
          type="text"
          value={displayValue}
          onChange={(e) => {
            const value = e.target.value;
            setProviderSearchText(value);
            setShowProviderDropdown(true);
            // Clear selected provider when user starts typing/editing
            // This allows backspace and typing to work properly
            if (selectedProviderId && value !== selectedProvider?.name) {
              onProviderSelect(null);
            }
          }}
          onFocus={() => setShowProviderDropdown(true)}
          placeholder={loading ? 'Loading providers...' : 'Search and select service provider...'}
          disabled={loading}
          className={`w-full px-4 py-2.5 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors ${
            loading ? 'bg-gray-100 cursor-not-allowed' : 'border-gray-300'
          }`}
        />
        {showProviderDropdown && filteredProviders.length > 0 && (
          <div
            ref={providerDropdownRef}
            className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto overflow-x-hidden"
            style={{ maxHeight: '240px' }}
          >
            {filteredProviders.map((provider) => (
              <div
                key={provider.id}
                onClick={() => onProviderSelect(provider)}
                className="px-4 py-2 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0 transition-colors"
              >
                {provider.name}
              </div>
            ))}
          </div>
        )}
        {showProviderDropdown && filteredProviders.length === 0 && !loading && (
          <div
            ref={providerDropdownRef}
            className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg p-4 text-center text-gray-500"
          >
            No providers found
          </div>
        )}
        {error && (
          <p className="mt-1 text-sm text-red-600">{error}</p>
        )}
      </div>
    </div>
  );
};

export default ProviderSelector;

